export enum IdentityRule {
  UNKNOWN = 'unknown',
  HOSTILE = 'hostile',
  FRIENDLY = 'friendly',
  NEUTRAL = 'neutral',
}
